"use client";

import { ReactNode, useEffect } from "react";
import { useRouter } from "next/navigation";
import { markAuthStore, selectIsUserLoggedIn } from "stores/auth/authSlice";
import { useAppDispatch, useAppSelector } from "stores/hooks";
type AppProtectedComponentProps = {
  children: ReactNode;
  isRedirectToHome?: boolean;
};
const AppProtectedComponent = ({
  children,
  isRedirectToHome = true
}: AppProtectedComponentProps) => {
  const router = useRouter();
  const dispatch = useAppDispatch();
  const isLoggedIn = useAppSelector(selectIsUserLoggedIn);
  useEffect(() => {
    if (isLoggedIn) return;
    if (isRedirectToHome) {
      void router.replace("/");
      return;
    }
    dispatch(markAuthStore({
      ui: {
        isLoginFlow: true,
        isSigningUpWithEmail: true,
        modalType: "LOGIN_WITH_EMAIL"
      }
    }));
  }, [isLoggedIn, dispatch, isRedirectToHome, router]);
  const handleOpenLoginModal = () => {
    dispatch(markAuthStore({
      ui: {
        isLoginFlow: true,
        isSigningUpWithEmail: true,
        modalType: "LOGIN_WITH_EMAIL"
      }
    }));
  };
  if (isLoggedIn) return <>{children}</>;
  if (isRedirectToHome) return <></>;
  return <div className='flex h-[400px] w-full flex-col items-center justify-center px-2' data-sentry-component="AppProtectedComponent" data-sentry-source-file="AppProtectedRoute.tsx">
      <p className='mb-4 text-center text-lg font-semibold text-grayText sxm:text-2xl'>
        Please log in to view this page
      </p>
      <button className='btn btn-primary h-12 w-[167px] px-8 text-base font-semibold' onClick={handleOpenLoginModal}>
        Log In
      </button>
    </div>;
};
export default AppProtectedComponent;